// extracted by mini-css-extract-plugin
module.exports = {"SmallWrapper":"loading_SmallWrapper__v8y5C","DefaultWrapper":"loading_DefaultWrapper___iEOK"};